import { CartCount,fetchCart } from "//98ff54-aa.myshopify.com/cdn/shop/t/50/assets/theme.js?v=30834797360561223251758079507";

var HeaderCartCount = class extends CartCount {
  constructor() {
   super();
  }
  async _updateFromServer() {
    let res = await fetchCart;
    if(res["total_price"] == 0){
      this.itemCount = 0;
    }else{
      let freeItems = res['items'].filter((item)=>item.price == 0 || item.handle.includes("free-gift"));
      let freeItemsLength = parseInt(freeItems.length);
      if((res["item_count"] - freeItemsLength) >= 0){
        this.itemCount = res["item_count"] - freeItemsLength;
      }else{
        this.itemCount = 0;
      }
      
    }
  }
}
if (!window.customElements.get("header-cart-count")) {
  window.customElements.define("header-cart-count", HeaderCartCount);
}

export {
  HeaderCartCount
}

